<template>
  <div class="search-modal">
    <div class="bg-white">
      <Header>
        <template v-slot:left>
          <FeatherIcon icon="chevron-left" @click="$emit('clickBack')" />
        </template>
        {{ title }}
      </Header>
      <div class="position-relative py-4 px-3">
        <slot />
        <div class="fixed-button-wrapper">
          <AppButton @click="$emit('save')" variant="success" block>
            設定
          </AppButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";

@Component({
  components: {
    AppButton,
    FeatherIcon,
    Header
  }
})
export default class SearchModal extends Vue {
  @Prop({
    type: String,
    default: ""
  })
  title!: string;
}
</script>

<style lang="scss" scoped>
.search-modal {
  position: fixed;
  top: 0;
  left: 0;
  // NOTE: 99のスタイルの上に表示するため100以上必要
  z-index: 200;
  width: 100%;
  height: 100vh;
  padding-bottom: 154px;
  overflow: auto;
  overscroll-behavior-y: contain;
  background: $white;
}

.fixed-button-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  padding: 8px 16px 28px;
  background: $white;
  border-top: 1px solid $gray-03;
}
</style>
